import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [agency, setAgency] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
      setCompany(r.data.company);
      setAgency(r.data.agency || null);
    } catch (e) {
      setUser(null);
      setCompany(null);
      setAgency(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout");
    setUser(null);
    setCompany(null);
    setAgency(null);
    window.location.href = "/";
  }, []);

  const value = useMemo(
    () => ({ user, company, agency, loading, setUser, setCompany, setAgency, checkAuth, logout }),
    [user, company, agency, loading, checkAuth, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
